import React from 'react'
import { Layout, Menu, theme } from 'antd'
import { Link, useLocation } from 'react-router-dom'
import { useContext } from 'react'
import { MyContext } from '../context'

const { Header, Content, Footer } = Layout
const _ = require('underscore')

const App = ({ children }) => {
  const { isLogin } = useContext(MyContext)
  const {
    token: { colorBgContainer }
  } = theme.useToken()
  const location = useLocation()
  let items = [
    {
      label: <Link to="/">首页</Link>,
      key: '/'
    },
    {
      label: <Link to="btc">BTC</Link>,
      key: '/btc'
    },
    {
      label: <Link to="announcement">公告</Link>,
      key: '/announcement'
    },
    {
      label: <Link to="euro">外汇牌价</Link>,
      key: '/euro'
    },
    {
      label: <Link to="zhihu">知乎</Link>,
      key: '/zhihu'
    },
    {
      label: '代码工具',
      key: '/code',
      children: [
        {
          label: <Link to="timestamp">时间戳</Link>,
          key: '/timestamp'
        },
        {
          label: <Link to="md5">MD5加密</Link>,
          key: '/md5'
        },
        {
          label: <Link to="src">HTML源码</Link>,
          key: '/src'
        },
        {
          label: <Link to="json2excel">JSON转Excel</Link>,
          key: '/json2excel'
        },
        {
          label: <Link to="google">Google搜索</Link>,
          key: '/google'
        }
      ]
    },
    {
      label: <Link to="wordcount">字数统计</Link>,
      key: '/wordcount'
    },
    {
      label: '图片工具',
      key: '/image',
      children: [
        {
          label: <Link to="idcard">证件照</Link>,
          key: '/idcard'
        },
        {
          label: <Link to="grid">九宫格图片</Link>,
          key: '/grid'
        },
        {
          label: <Link to="merge">拼接图片</Link>,
          key: '/merge'
        },
        {
          label: <Link to="ps">抠图</Link>,
          key: '/ps'
        },
        {
          label: <Link to="ocr">识别文字</Link>,
          key: '/ocr'
        }
      ]
    },
    {
      label: 'PDF工具',
      key: '/pdf',
      children: [
        {
          label: <Link to="mergePdf">合并PDF</Link>,
          key: '/mergePdf'
        },
        {
          label: <Link to="image2pdf">图片转PDF</Link>,
          key: '/image2pdf'
        },
        {
          label: <Link to="pdf2image">PDF转图片</Link>,
          key: '/pdf2image'
        }
      ]
    },
    {
      label: 'Office工具',
      key: '/office',
      children: [
        {
          label: <Link to="mergeDoc">合并Word</Link>,
          key: '/mergeDoc'
        },
        {
          label: <Link to="doc2Pdf">Word转PDF</Link>,
          key: '/doc2Pdf'
        }
      ]
    },
    {
      label: '视频音频',
      key: '/video_audio',
      children: [
        {
          label: <Link to="audio">音频播放</Link>,
          key: '/audio'
        },
        {
          label: <Link to="video">视频下载</Link>,
          key: '/video'
        }
      ]
    }
  ]
  // remove menu item if not login
  if (!isLogin) {
    items = items.filter(item => {
      return !['/btc', '/announcement', '/euro', '/zhihu'].includes(item.key)
    })
  }
  React.useEffect(() => {
    // 看来要使用递归去找出子菜单了
    // useEffect 第二个参数不传，连空数组也不传，正好实现了，每次渲染都执行它
    const key = location.pathname
    // console.log(items)
    // console.log(key)
    // result为展开后的菜单数组
    const result = []
    const pick = items => {
      // 递归展开菜单项为一维数组
      for (let index = 0; index < items.length; index++) {
        const element = items[index]
        if (element['children']) {
          pick(element['children'])
        } else {
          result.push(element)
        }
      }
    }
    pick(items)
    // console.log(result)
    const item = _.find(result, element => {
      return element.key === key
    })
    if (item) {
      const title = item.label.props.children
      document.title = title
    }
  })
  return (
    <Layout className="layout">
      <Header
        style={{
          display: 'flex',
          alignItems: 'center',
          paddingLeft: '0', // layout默认主题变量里自带了padding: 0 50px，所以覆盖它
          paddingRight: '0'
        }}
      >
        <div style={{ minWidth: '390px' }}>
          <Menu
            theme="dark"
            mode="horizontal"
            // onClick={handleClick} 使用了useEffect兼加载时显示标题时，同时将它解决了
            selectedKeys={[`${location.pathname}`]}
            items={items}
          />
        </div>
      </Header>
      <Content
        style={{
          marginTop: '30px'
        }}
      >
        <div
          className="site-layout-content"
          style={{
            background: colorBgContainer,
            padding: '30px 0',
            height: '100%'
          }}
        >
          {children}
        </div>
      </Content>
      <Footer
        style={{
          textAlign: 'center'
        }}
      >
        Easy Tools ©2023 Created by HuangXiuJie
      </Footer>
    </Layout>
  )
}
export default App
